module.exports = __webpack_public_path__ + "img/NEWS.b7a95cbb.png";